import MarketplaceItemVariantsTable from './MarketplaceItemVariantsTable'

export default MarketplaceItemVariantsTable
